<template>
  <ul>
    <li
      v-for="(item, index) in items"
      :key="keyName && `${item[keyName]}-${index}}` || index"
      :data-testid="item.value"
    >
      <slot
        name="item"
        :index="index"
        :item="item"
      />
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

type ListItem = Record<string, unknown>

export default defineComponent({
  props: {
    items: {
      type: [Array, Object, Set] as PropType<ListItem[] | Record<string, ListItem> | Set<ListItem>>,
      required: true,
    },

    keyName: {
      type: [String, Number] as PropType<string | number>,
      default: 'id',
    },
  },
})
</script>
